import React from "react";
import { TSubcase } from "../data-access/types";
import useDiffComponentFactory from "./useDiffComponentFactory";

export default function CaseAccordionDetails({
  subcase,
  diff,
}: {
  subcase: TSubcase;
  diff: any;
}) {
  const { component: Component, props: getProps } = useDiffComponentFactory(
    subcase.type,
  );

  const componentProps = getProps(diff);

  return <Component {...componentProps} />;
}
